import React from "react";
import {
  BuilderFieldButton,
  BuilderFieldCategoryName,
} from "../../../SubmissionsBuilder/__styles__/SubmissionsBuilder";
import { useBuilderWatch } from "../../form/form";
import { useAddModule } from "../../modules/add";
import { MODULES } from "../../modules/list";
import { BuilderFieldListItem, BuilderFieldsList } from "./__styles__/shared";

export function ModulesList() {
  const addModule = useAddModule();

  const selectedModules = useBuilderWatch("modules");
  const addableModules = MODULES.filter(
    ({ type }) => !selectedModules.includes(type),
  );

  if (!addableModules.length) {
    return null;
  }

  return (
    <div>
      <BuilderFieldCategoryName>Modules</BuilderFieldCategoryName>
      <BuilderFieldsList>
        {addableModules.map(module => {
          const { label } = module;

          return (
            <BuilderFieldListItem key={label}>
              <BuilderFieldButton
                styleVariant="ghost"
                leftIconName="component"
                aria-label={`Add ${label} Module`}
                onClick={() => {
                  addModule(module);
                }}
              >
                {label}
              </BuilderFieldButton>
            </BuilderFieldListItem>
          );
        })}
      </BuilderFieldsList>
    </div>
  );
}
